import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router, ActivatedRoute} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";
import {LaudosPdfModel} from "../laudos-pdf/laudos-pdf.model";
import {LaudosPdfService} from "../laudos-pdf/laudos-pdf.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ClientesService} from "../clientes/clientes.service";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {FichasService} from "../fichas/fichas.service";
import {TiposClientesService} from "../clientes/tipos-clientes.service";
import {UnidadesService} from "../unidades/unidades.service";
import {FaturasService} from "../faturas/faturas.service";
import {TerminaisService} from "../terminais/terminais.service";

declare let swal, $: any;

@Component({
  selector: 'app-financeiro-laudos-pdf-cliente',
  templateUrl: './financeiro-laudos-pdf-cliente.component.html'
})
export class FinanceiroLaudosPdfClienteComponent extends Components implements OnInit {

  formAlterarValor: FormGroup;
  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"status_pesquisa":"", "data_de":"", "data_ate":"", "mercadoria":"", "cliente":"", "terminal":"", "id_unidade": "", "conhecimento": ""};
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  laudos: LaudosPdfModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listStatusFichas = [];
  listMercadorias = [];
  listTerminal = [];
  listUnidades = [];
  idCliente: string;

  selecionarTodos: boolean = false;
  selecionados: any = {};

  alterar_valor = {
    "id_laudo": null,
    "valor": ""
  };

  listFaturado = [{
    "texto": "Sim",
    "valor": 1
  },{
    "texto": "Não",
    "valor": 0
  }];

  faturar = {
    "id_laudo": null,
    "data": ""
  };

  faturarEmMassa = {
    "data": ""
  };

  formFaturar: FormGroup;
  carregandoBotaoFaturar: boolean = false;
  carregandoBotaoAlterarValor: boolean = false;


  constructor(
    formBuilder: FormBuilder,
    private laudosService: LaudosPdfService,
    private fichasService: FichasService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private tiposClientesService: TiposClientesService,
    private unidadesService: UnidadesService,
    private faturasService: FaturasService,
    private terminaisService: TerminaisService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    private route: ActivatedRoute,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8)+'01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'financeiro'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      mercadoria: [],
      terminal: [],
      id_unidade: [],
      conhecimento: []
    });

    this.formAlterarValor = formBuilder.group({
      valor: []
    });

    this.formFaturar = formBuilder.group({
      data: [],
      data_faturar_massa: []
    });

    this.fichasService.getStatus()
      .subscribe(
        json => {
          this.listStatusFichas = json.Payload;
        });

    // busca terminais
    this.terminaisService.get()
      .subscribe(
        json => {
          this.listTerminal = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.mercadoriasService.get(null, null, ['id', 'nome_pt'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        });

    // busca unidades
    this.unidadesService.get(null, null, ['id_unidade', 'nome_tratamento'])
      .subscribe( json => {
        this.listUnidades = json.Payload;
      });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idCliente = params['id_cliente'];
      this.filtroPesquisa.cliente = this.idCliente;

      let filtroSalvo = this.carregaFiltro();
      if (filtroSalvo) {
        this.filtroPesquisa = filtroSalvo;
        this.filtroPesquisa.cliente = this.idCliente;
        this.formPesquisaAvancada.patchValue(filtroSalvo);
      }
      this.carregandoTabela = true;
      this.getPage(1);
    });
  }

  delete(ficha) {
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarFicha')+ficha.id_laudo,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        let index = self.laudos.indexOf(ficha);
        self.laudos.splice(index, 1);

        self.laudosService.apagar(ficha.id_laudo)
          .subscribe(res => {
            },
            err => {
              self.laudos.splice(index, 0, ficha);
              self.func.showErro(err.json());
            });
      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    filtros['id_status'] = 2;
    filtros['id_cliente'] = this.idCliente;

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data'] = 'ge:' + this.filtroPesquisa.data_de;
      }
      if (this.filtroPesquisa.data_ate) {
        filtros['data'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }
    if(this.filtroPesquisa.terminal != ''){
      filtros['id_terminal'] = this.filtroPesquisa.terminal;
    }
    
    filtros['faturado'] = '0'; // Apenas Não Faturadas
    
    if(this.filtroPesquisa.id_unidade != ''){
      filtros['id_unidade'] = this.filtroPesquisa.id_unidade;
    }

    if(this.filtroPesquisa.conhecimento != ''){
      filtros['conhecimento'] = "**:"+this.filtroPesquisa.conhecimento;
    }

    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria', 'cliente_moeda', 'terminal', 'unidade', 'status'], filtros)
      .subscribe(data => {
          this.laudos = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  enviaParaCliente(id){
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaEnviarFichaCliente'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        self.laudosService.enviarLaudoParaCliente(id).subscribe(res => {}, err => { self.func.showErro(err.json()); });
      });
  }

  alteraStatus(id_laudo, id_status){
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaAlterarStatus'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){
        self.laudosService.setStatus(id_laudo, id_status)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");
              self.func.showErro(error.json());
            });
      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"status_pesquisa":"", "data_de":"", "data_ate": "", "mercadoria":"", "cliente":this.idCliente, "terminal":"", "id_unidade": "", "conhecimento": ""};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  modalAlterarValor(id_laudo, valor){
    this.alterar_valor["id_laudo"] = id_laudo;
    this.alterar_valor["valor"] = valor;
    $('#modalAlterarValor').modal('show');
  }

  alterarValor(){
    this.carregandoBotaoAlterarValor = true;
    this.laudosService.setValor(this.alterar_valor["id_laudo"], this.alterar_valor["valor"])
      .subscribe(res => {
          this.carregandoBotaoAlterarValor = false;
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.statusAlterado'), "success");
          this.getPage(this.paginaAtual);
          $('#modalAlterarValor').modal('hide');
        },
        error => {
          this.carregandoBotaoAlterarValor = false;
          this.func.showErro(error.json());
          $('#modalAlterarValor').modal('hide');
        });
  }

  limpaAlteraValor(){
    this.alterar_valor = { "id_laudo": null, "valor": "" };
    $('#modalAlterarValor').modal('hide');
  }

  modalFaturar(id_laudo){
    this.faturar["id_laudo"] = id_laudo;
    this.faturar["data"] = new Date().toISOString().substr(0, 10);
    $('#modalFaturar').modal('show');
  }

  confirmarFaturar(){
    this.carregandoBotaoFaturar = true;
    this.laudosService.faturarLaudo(this.faturar["id_laudo"], this.faturar["data"])
      .subscribe(res => {
          this.carregandoBotaoFaturar = false;
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
          this.getPage(this.paginaAtual);
          $('#modalFaturar').modal('hide');
        },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        });
  }

  limpaFaturar(){
    this.faturar = { "id_laudo": null, "data": "" };
    $('#modalFaturar').modal('hide');
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.laudos.forEach(laudo => {
      this.selecionados[laudo.id_laudo] = this.selecionarTodos;
    });
  }

  marcarItem(laudo, event) {
    this.selecionados[laudo.id_laudo] = event.target.checked;
    
    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      let todosMarcados = true;
      for (let l of this.laudos) {
        if (!this.selecionados[l.id_laudo]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  modalFaturarEmMassa(){
    let selecionadosIds = this.getSelecionadosIds();
    if(selecionadosIds.length == 0){
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    this.faturarEmMassa["data"] = new Date().toISOString().substr(0, 10);
    $('#modalFaturarEmMassa').modal('show');
  }

  confirmarFaturarEmMassa(){
    this.carregandoBotaoFaturar = true;
    let selecionadosIds = this.getSelecionadosIds();

    this.faturasService.faturarLaudosAvulsos(selecionadosIds, this.faturarEmMassa["data"])
      .subscribe(res => {
          this.carregandoBotaoFaturar = false;
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
          this.getPage(this.paginaAtual);
          this.selecionados = {};
          this.selecionarTodos = false;
          $('#modalFaturarEmMassa').modal('hide');
        },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        });
  }

  private getSelecionadosIds(): string[] {
    let ids = [];
    for(let id in this.selecionados){
      if(this.selecionados[id]){
        ids.push(id);
      }
    }
    return ids;
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/financeiro-laudos-pdf-cliente.component.ts